import api from './Api';

class CollaboratorSizeRangeService {
  constructor() {
    this.api = api;
  }

  getAll() {
    return this.api.get('/collaborator-range/');
  }
}

const collaboratorSizeRangeService = new CollaboratorSizeRangeService();
export default collaboratorSizeRangeService;
